import React from 'react';
import { Helmet } from 'react-helmet-async';
import { PAGE_SEO, SITE } from '../data/seoContent';

const abs = (p) => SITE + (p === '/' ? '/' : p);

// `page` looks up PAGE_SEO; `seo` overrides it (e.g. generated area pages). Adds BreadcrumbList automatically.
export const Seo = ({ page, seo, jsonLd }) => {
  const s = { ...(PAGE_SEO[page] || {}), ...(seo || {}) };
  const url = abs(page);
  const image = `${SITE}/share/${s.image}.jpg`;
  const crumbs = page === '/' ? null : {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: abs('/') },
      ...(s.parent ? [{ '@type': 'ListItem', position: 2, name: s.parent.name, item: abs(s.parent.path) }] : []),
      { '@type': 'ListItem', position: s.parent ? 3 : 2, name: s.name || s.title.split('|')[0].trim(), item: url },
    ],
  };
  const lds = [crumbs, ...(Array.isArray(jsonLd) ? jsonLd : [jsonLd])].filter(Boolean);
  return (
    <Helmet>
      <title>{s.title}</title>
      <meta name="description" content={s.description} />
      <meta name="keywords" content={s.keywords} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Leisure Wellness Naples" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={s.title} />
      <meta property="og:description" content={s.description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={s.alt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={s.title} />
      <meta name="twitter:description" content={s.description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={s.alt} />
      {lds.map((ld, i) => <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>)}
    </Helmet>
  );
};

export default Seo;
